import React from 'react';
import { colorPalette } from '../../../colorPalette';
import Box from "@mui/material/Box";
export const DiscountSoldesLabel = ({ discountText, labelText, backgroundTextColor, backgroundDiscountColor, margin, }) => {
    const labelStyle = {
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '15px',
        letterSpacing: '1px',
        margin: margin || 0,
    };
    const labelTextStyle = {
        backgroundColor: colorPalette[backgroundTextColor],
        color: colorPalette[backgroundDiscountColor],
        padding: '4px',
        borderRadius: '4px 0px 0px 4px',
    };
    const discountStyle = {
        backgroundColor: colorPalette[backgroundDiscountColor],
        color: colorPalette.white,
        padding: '4px',
        borderRadius: '0px 4px 4px 0px',
    };
    return (React.createElement(Box, { component: "span", sx: labelStyle, "data-qa": "discount-soldes-label" },
        React.createElement(Box, { component: "span", sx: labelTextStyle }, labelText),
        React.createElement(Box, { component: "span", sx: discountStyle }, discountText)));
};
